import React, { useState } from "react";
import { Card, Tabs, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import "./RecruiterActionsCard.css"; // <--- Import your CSS file here

export default function RecruiterActionsCard() {
  const [activeTab, setActiveTab] = useState("all");

  const recruiterActions = [
    { id: 1, type: "contacted", company: "Countrywide Immigration Private Limited", time: "4 days ago" },
    { id: 2, type: "downloaded", company: "Siddiquis Elite India Inspection And Survey Private Limited", time: "A month ago" },
    { id: 3, type: "contacted", company: "Siddiquis Elite India Inspection And Survey Private Limited", time: "A month ago" },
  ];

  const totalCount = recruiterActions.length;
  const viewCount = recruiterActions.filter((a) => a.type === "viewed").length;
  const downloadCount = recruiterActions.filter((a) => a.type === "downloaded").length;
  const contactCount = recruiterActions.filter((a) => a.type === "contacted").length;

  const filteredActions = recruiterActions.filter((action) => {
    if (activeTab === "all") return true;
    return action.type === action.type; // Adjust logic as needed based on your type naming
  });

  const RenderFeedList = () => (
    <div className="timeline-feed d-flex flex-column gap-3 mt-4">
      {filteredActions.length > 0 ? (
        filteredActions.map((action) => (
          <div key={action.id} className="feed-item d-flex gap-3 align-items-start pb-3 border-bottom">
            <div className="feed-icon bg-danger-subtle text-danger rounded">
              <FontAwesomeIcon icon={faBuilding} />
            </div>
            <div>
              <p className="small mb-1 text-dark">
                Recruiter from <strong className="fw-bold">{action.company}</strong> has{" "}
                <strong className="fw-bold">{action.type}</strong> you!
              </p>
              <span className="extra-small text-muted d-block">{action.time}</span>
            </div>
          </div>
        ))
      ) : (
        <p className="text-muted small my-3">No actions found for this category.</p>
      )}
    </div>
  );

  return (
    /* Added the parent wrapper class 'recruiter-actions-card' here */
    <Card className="score-card recruiter-actions-card"> 
      <Card.Body className="score-card__body">
        <h4 className="fw-bold mb-3">
          {totalCount} <span className="fs-6 fw-normal text-dark">Recruiter actions on your profile</span>
        </h4>

        <Tabs
          id="recruiter-actions-tabs"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k || "all")}
          className="custom-pill-tabs border-0"
          variant="pills"
        >
          <Tab eventKey="all" title={`All (${totalCount})`}>
            <RenderFeedList />
          </Tab>
          <Tab eventKey="viewed" title={`Profile views (${viewCount})`}>
            <RenderFeedList />
          </Tab>
          <Tab eventKey="downloaded" title={`Resume downloaded (${downloadCount})`}>
            <RenderFeedList />
          </Tab>
          <Tab eventKey="contacted" title={`Contacted (${contactCount})`}>
            <RenderFeedList />
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
}